import React, {createContext, useContext} from 'react';
import classNames from 'classnames';
import {useIntl} from 'react-intl';
import {SVGS} from '../../../assets/images';
import {TableTag} from '../../../components/shared/table-tag';
import {Lx} from '../../../i18n/consts';
import styles from '../time-tracking-import.module.scss';

export interface ManualRowContextValue {
    /** A preview request is in flight — nothing can be changed until the server answers. */
    isPending: boolean;
    isSupported: boolean;
    onAdd: (employeeValue: string) => void;
}

const ManualRowContext = createContext<ManualRowContextValue | null>(null);

export const ManualRowProvider = ManualRowContext.Provider;

export const useManualRowContext = () => useContext(ManualRowContext);

export const ManualRowAddButton: React.FC<{employeeValue: string}> = ({employeeValue}) => {
    const intl = useIntl();
    const context = useManualRowContext();

    if (!context?.isSupported) {
        return null;
    }

    return (
        <button
            type='button'
            className={styles.manualRowAddButton}
            disabled={context.isPending}
            onClick={() => context.onAdd(employeeValue)}
        >
            <SVGS.PlusIcon />
            <span>{intl.formatMessage({id: Lx.TimeTrackingImport.MANUAL_ROW_ADD})}</span>
        </button>
    );
};

/** Row origin mark: added by hand or rewritten over a file row. */
export const ManualRowTag: React.FC<{labelId: string}> = ({labelId}) => {
    const intl = useIntl();

    return (
        <TableTag
            label={intl.formatMessage({id: labelId})}
            className={classNames(styles.previewNewEntityTag, styles.secondaryTableTag)}
            classes={{label: styles.previewNewEntityTagLabel}}
        />
    );
};
